export function initPurchases(authorizationToken, environment, isPaypal = true, successCallback = null, errorCallback = null, hostedFieldsCreatedCallback = null, initialCardNumberPlaceholder = 'XXXX XXXX XXXX XXXX') {
    let submitBtn = document.getElementById('submit-btn');
    let errorMessage = document.getElementById('error-message');
    let purchaseForm = document.getElementById('purchase-form');
    let cardToken = document.getElementById('card-token');

    braintree.client.create({authorization: authorizationToken}).then(function (client) {

        if (isPaypal) {
            braintree.paypalCheckout.create({
                client: client
            }, function (err, paypalCheckoutInstance) {
                if (err) {
                    console.error(err);
                    return;
                }

                return paypal.Button.render({
                    env: environment,

                    payment: function () {
                        return paypalCheckoutInstance.createPayment({
                            flow: 'vault',
                            amount: 49,
                            currency: 'USD'
                        });
                    }.bind(this),
                    style: {
                        color: 'blue',
                        size: 'medium',
                        shape: 'rect',
                        label: 'pay',
                        tagline: false
                    },
                    onAuthorize: function (data, actions) {
                        // some logic here before tokenization happens below
                        return paypalCheckoutInstance.tokenizePayment(data).then(function (payload) {
                            cardToken.value = payload.nonce;

                            if (successCallback) {
                                successCallback();
                            }

                            purchaseForm.submit();
                        }.bind(this));
                    }.bind(this)
                }, '#paypal-button');
            }.bind(this));
        }

        braintree.hostedFields.create({
            client: client,
            styles: {
                'color': '#000',
                'font-size': '12px'
            },
            fields: {
                cvv: {
                    placeholder: '123',
                    selector: '#card-cvv'
                },
                expirationDate: {
                    placeholder: 'MM/YY',
                    selector: '#card-expiry'
                },
                number: {
                    placeholder: initialCardNumberPlaceholder,
                    selector: '#card-number'
                }
            }
        }).then(function (hostedFields) {
            if (hostedFieldsCreatedCallback) {
                hostedFieldsCreatedCallback(hostedFields);
            }

            submitBtn.addEventListener('click', function (event) {
                event.preventDefault();
                submitBtn.setAttribute('disabled', 'disabled');
                errorMessage.classList.add('d-none');

                hostedFields.tokenize().then(function (payload) {
                    if (successCallback) {
                        successCallback();
                    }

                    cardToken.value = payload.nonce;
                    purchaseForm.submit();
                }).catch(function (err) {
                    let elements = document.querySelectorAll('.card-data');
                    for (let i = 0; i < elements.length; i++) {
                        elements[i].classList.remove('has-error');
                    }
                    if (err.details != null) {
                        for (let i = 0; i < err.details.invalidFieldKeys.length; i++) {
                            document.querySelector('.' + err.details.invalidFieldKeys[i]).classList.add('has-error');
                        }
                    } else {
                        for (let i = 0; i < elements.length; i++) {
                            elements[i].classList.add('has-error');
                        }
                    }
                    submitBtn.removeAttribute('disabled');
                    errorMessage.innerHTML = err.message;
                    errorMessage.classList.remove('d-none');

                    if (errorCallback) {
                        errorCallback();
                    }
                });
            })
        });
    });
}



// WEBPACK FOOTER //
// ./resources/assets/js/purchases.js